/**
 * UI控件库 
 * @module UI
 */

;(function (ui,$) {
  "use strict";
    /**
     * <h3>星级评分</h3>
     * <a href="../../ui_controls/bui.rating.html" target="_blank">demo</a>
     * <p>支持一颗星,支持半颗星</p>
     * <h5>方法</h5>
     * {{#crossLink "bui.rating/option"}}{{/crossLink}}: 获取设置参数 <br>
     * {{#crossLink "bui.rating/widget"}}{{/crossLink}}: 获取依赖控件 <br>
     * {{#crossLink "bui.rating/value"}}{{/crossLink}}: 不传参则获取,传参则设置 <br>
     * {{#crossLink "bui.rating/disabled"}}{{/crossLink}}: 更改为展示星星 <br>
     *  @namespace bui
     *  @class rating
     *  @constructor 
     *  @param {object} option  
     *  @param {string} option.id [控件id]    
     *  @param {string} [option.handle] [点击的区域,属于循环的那部分]  
     *  @param {boolean} [option.half] [是否支持半颗星]  
     *  @param {number} [option.stars] [显示多少颗星星]
     *  @param {number} [option.value] [初始化多少颗星星]
     *  @param {number} [option.show] [展示多少颗星星比如 3.6 最后一颗星星会转换成60%]
     *  @param {boolean} [option.disabled] [是否只读]
     *  @param {boolean} [option.render] [ true | false 默认true,这样无需填写复杂的结构]
     *  @param {function} [option.callback] [ 点击按钮的回调 ]  
     *  @example
     * 
     *   html:
     *
            <div id="rating" class="bui-rating"></div>
     *      
     *   js: 
     *   
            // 初始化
            var uiRating = bui.rating({
                        id:'#rating'
                    });
            //获取值
            uiRating.value(); 
     *
     */   
    ui.rating = function(option){

        var config = {
            id: "",
            handle: ".bui-rating-cell",
            fullClassName: "bui-rating-cell-full",
            halfClassName: "bui-rating-cell-half",
            half: false,   
            stars: 5,      
            value: 0,      
            disabled: false,
            render: true,  
            callback: null
        };
        //方法
        var module = {
            disabled: disabled,
            show: show,
            value: value,
            widget: widget,
            option: options,
            config: param,
            init: init
        };
        //用于option方法的设置参数
        var param = module.config = $.extend(true,{}, config, ui.config.rating, option );

        var $id,
            el,
            fullClass,
            halfClass,
            val,
            $handle;

        //初始化
        init(param);

        //初始化
        function init (option) {
            option = option || param;
            
            if( option.id ){
                $id = ui.obj(option.id);
            }else{
                ui.hint("rating id不能为空");
                return;
            }

            //option获取新参数使用
            param = module.config = option;

            fullClass = option.fullClassName;
            halfClass = option.halfClassName;

            //初始化
            display(option);

            //绑定点击事件
            bind(option);

            return this;
         }   

         function template (option) {

           var guid = ui.guid();
           var html = "",
                i = 0,
                length = option.stars;

              for( i=0; i< length; i++ ){
                html += '<div class="bui-rating-cell" ></div>';
              }

              return html;
         }

         function showTemplate (num) {

           var html = "",
                num = String(num) || String(val),
                percent,
                i = 0,
                length = param.stars;

           var groupNum = [];
              groupNum = num.indexOf(".") > -1 ? num.split(".") : [num,0];

           var intValue = parseInt(groupNum[0]);
              percent = (groupNum[1]/10)*100+"%" ; 

              for( i=0; i< length; i++ ){

                if( i < intValue ){

                html += '<div class="bui-rating-cell" ><div class="bui-rating-cell-full" style="width:100%;">&nbsp;</div></div>';
                }
                if( i == intValue ){
                
                html += '<div class="bui-rating-cell" ><div class="bui-rating-cell-full" style="width:'+percent+';">&nbsp;</div></div>';

                }
                if( i > intValue ){
                html += '<div class="bui-rating-cell" ><div class="bui-rating-cell-full" style="width:0;">&nbsp;</div></div>';

                }
              }

              return html;
         }


         //绑定事件
         function bind (option) {

            if( !option.disabled ){

              //是整数还是浮点数
              var click = String(option.value).indexOf(".")>-1 ? 1: 0;

              $id.off("click.bui",option.handle).on("click.bui",option.handle,function  (e) {

                  var index = $(this).index();
                  var num = 0;
                  //是否支持一半
                  if( option.half ){
                    var classname = click%2 == 0 ? halfClass: fullClass;
                    num = click%2 == 0 ? index +0.5: index +1;

                  }else{
                    num = index +1;
                  }

                  //添加星星
                  rating(num);
                  //设置点击以后的值
                  value(num);

                  //累计点击了多少次
                  click++;

                  option.callback && option.callback.call(this,module);

                  e.stopPropagation();
               })
            }
            
         }

         //初始化显示的状态
         function display (option) {
          
           if( option.render ){
              var html = template( option );

              $id.html(html);

              $handle = $id.find( option.handle );
            
           }else{
              $handle = $id.find( option.handle );
           }

           //rating( option.value );
           // if( !option.disabled ){

            value(option.value);
           // }else{
           //  show(option.value);
           // }

         }

         //新增星星
         function rating (index) {

            //是否有小数点
            var indexs = [];
                index = String(index);

            if( param.half && index.indexOf(".")>-1 ){
              indexs = index.split('.');

            }else{
              indexs.push(index);
            }

            //移除所有星星
           $handle.removeClass(fullClass)
                      .removeClass(halfClass);

           $handle.each(function (i,item) {
              //如果长度1未则是整数
              if( indexs.length == 1 && i < indexs[0] ){
                $(item).addClass(fullClass);
              }else if( indexs.length == 2 ){

                if( i < indexs[0] ){
                   $(item).addClass(fullClass);
                }

                if( i == indexs[0] ){
                  $(item).addClass(halfClass);
                }
              }
                
            })
         }

         /**
         * 设置星星的值
         *  @method value
         *  @chainable
         *  @param {string} [num] [设置值]
         *  @example 
            
            //设置值
            uiRating.value(3);

            //获取值
            var val = uiRating.value();
                
         */
         function value (num) {

           if( num ){

            $id.attr("value",num);

            rating( num );
            val = num;

           }else{
            val = $id.attr("value");
           }
           
           return val;

         }

         /**
         * 展示评分的星星值,只读,支持星星的百分比展示
         *  @method show
         *  @chainable
         *  @param {string} [num] [设置值]
         *  @example 
            
            //设置值
            uiRating.show(3);
                
         */
         function show(num) {
          
           var html = showTemplate( num );

           $id.attr("value",num).html(html);

           val = num;
         }
        /**
         * 禁止评分
         *  @method disabled
         *  @chainable
         *  @param {boolean} [bool] [禁止输入 true | false]
         *  @example 
            
            //禁止评分
            uiRating.disabled();
                
         */
        function disabled (bool) {

            var bool = bool == false ? false: true;
            if( bool ){

                $id.off("click.bui",param.handle);
            }else{
                
                param.disabled = false;
                bind()
            }

            return this;
        }

        /**
         * 获取依赖的控件
         *  @method widget
         *  @param {string} [name] [ 依赖控件名 ]
         *  @example 
            
            //获取依赖控件
            var uiRatingWidget = uiRating.widget();
            
                
         */
        function widget(name) {
            var control = {};
            return ui.widget.call(control,name);
        };
        /**
         * 获取设置参数
         *  @method option
         *  @param { string | object } [key] [ 不传则获取所有参数, 类型为string,没有第2个参数则获取某个参数 ]
         *  @param { string | number | boolean | function } [value] [ 设置参数的时候要传,设置多个参数不用传,获取参数的时候也不用传 ]
         *  @chainable
         *  @example 
            
            
            //获取所有参数
             //获取所有参数
            var option = uiRating.option();

            //获取某个参数
            var id = uiRating.option( "id" );

            //修改一个参数
            uiRating.option( "half",false );

            //修改多个参数
            uiRating.option( {"half":false} );
                
         */
        function options (key,value) {

           return ui.option.call(module,key,value);
        }
         return module;
    };

    return ui;

})( bui || {}, libs );
